<tgrid-sidebar-group [title]="mapLayerGroup().displayName">
  @for (layer of mapLayerGroup().layers; track layer.id) {

    @switch (layer.serviceType) {
      @case (serviceType.GEOJSON) {

        @switch (layer.uiHandle) {
          @case ('restorationMetrics') {
            <tgrid-restoration-metric-layer [mapLayer]="layer"></tgrid-restoration-metric-layer>
          }
          @case ('countyCoverage') {
            <tgrid-county-coverage-layer [mapLayer]="layer"></tgrid-county-coverage-layer>
          }
          @case ('outageEventCount') {
            <tgrid-outage-event-count-layer [mapLayer]="layer"></tgrid-outage-event-count-layer>
          }
          @case ('hhsEmpower') {
            <tgrid-hhs-empower-layer [mapLayer]="layer"></tgrid-hhs-empower-layer>
          }
          @case ('vaDataCenters') {
            <tgrid-va-data-center-layer [mapLayer]="layer"></tgrid-va-data-center-layer>
          }
          @case ('iceCountySummary') {
            <tgrid-ice-layer [mapLayer]="layer"></tgrid-ice-layer>
          }
          @case ('nighttimeLightOutage') {
            <tgrid-nighttime-lights-layer [mapLayer]="layer"></tgrid-nighttime-lights-layer>
          }
          @case ('countySrcCurves') {
            <tgrid-county-src-layer [mapLayer]="layer"></tgrid-county-src-layer>
          }
          @default {
            <p style="display: flex; gap: 10px; align-items: center;">
              <vulcan-icon icon="warning" size="24px"></vulcan-icon>
              No layer defined for: <br> {{ layer.displayName }}
            </p>
          }
        }
      }
      @case (serviceType.WMS) {
        <tgrid-map-layer [mapLayer]="layer"></tgrid-map-layer>
      }
      @case (serviceType.ARCGIS) {
        <p>No Default ARCGIS Layer defined</p>
      }
      @case (serviceType.VECTORTILE) {
        @if (layer.uiHandle === 'topsisRank') {
          <tgrid-county-ranking-layer [mapLayer]="layer"></tgrid-county-ranking-layer>
        }
        @if (layer.uiHandle === 'substationHeadroom') {
          <tgrid-substation-headroom-layer [mapLayer]="layer"></tgrid-substation-headroom-layer>
        }
        @if (layer.uiHandle === 'datacenters') {
          <tgrid-datacenters-layer [mapLayer]="layer"></tgrid-datacenters-layer>
        }
        @if (layer.uiHandle === 'countyAffordability') {
          <tgrid-affordability-layer [mapLayer]="layer"></tgrid-affordability-layer>
        }
      }
      @default {
        <p>Unknown service type: {{ layer.serviceType }}</p>
      }
    }
  }
</tgrid-sidebar-group>
